import { render, staticRenderFns } from "./bucket-details.html?vue&type=template&id=31edded0&scoped=true&external"
import script from "./bucket-details.js?vue&type=script&lang=js&external"
export * from "./bucket-details.js?vue&type=script&lang=js&external"
import style0 from "./bucket-details.scss?vue&type=style&index=0&id=31edded0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31edded0",
  null
  
)

export default component.exports